/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'recherche': {
    width: 72,
    height: 72,
    viewBox: '0 0 72 72',
    data: '<g stroke-linejoin="round" _fill="#005BA5" fill-rule="nonzero"><path pid="0" d="M50.658 40.887l.354-.353a7.41 7.41 0 10-10.478 10.478 7.41 7.41 0 0010.478-10.478l-.354.353zm0 0l-.353.354a6.41 6.41 0 11-9.064 9.064 6.41 6.41 0 019.064-9.064l.353-.354z"/><path pid="1" d="M50.307 51.014l5.476 5.476a.5.5 0 10.707-.707l-5.476-5.476a.5.5 0 00-.707.707z"/><g stroke-linecap="round"><path pid="2" d="M48.395 22.2v-3.556H25.49V15.09H15.081v28.355c0 1.915 1.538 3.467 3.443 3.467 1.903 0 3.443-1.553 3.443-3.467V23.8h28.352v8.089h1.6V22.2h-3.524zm-1.6 0H20.367v21.244a1.855 1.855 0 01-1.843 1.867 1.852 1.852 0 01-1.843-1.867V16.69h7.21v3.555h22.904V22.2z"/><path pid="3" d="M18.524 46.911h13.214v-1.6H18.524z"/></g></g>'
  }
})
